
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="禁用列宽拖动" fileName="disable-resizing.md" />
        <p>以下示例，列 Col1、Col2、Col3 列宽拖动通过 <code>disableResizing</code>被禁用了</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        style=&quot;width:100%&quot;
        :scroll-width=&quot;0&quot;
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        :border-around=&quot;true&quot;
        :border-x=&quot;true&quot;
        :border-y=&quot;true&quot;
        :column-width-resize-option=&quot;columnWidthResizeOption&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    import Mock from &quot;mockjs&quot;;
    export default {
        data() {
            return {
                columnWidthResizeOption: {
                    // default false
                    enable: true,
                    // column resize min width
                    minWidth: 30,
                    // column size change
                    sizeChange: ({ column, differWidth, columnWidth }) =&gt; {
                        //
                    },
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;index&quot;,
                        title: &quot;#&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        fixed: &quot;left&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                        disableResizing: true,
                    },
                    {
                        field: &quot;col1&quot;,
                        key: &quot;col1&quot;,
                        title: &quot;Col1&quot;,
                        width: 220,
                        disableResizing: true,
                    },
                    {
                        field: &quot;col2&quot;,
                        key: &quot;col2&quot;,
                        title: &quot;Col2&quot;,
                        width: 220,
                        disableResizing: true,
                    },
                    { field: &quot;col3&quot;, key: &quot;col3&quot;, title: &quot;Col3&quot;, width: 220 },
                    { field: &quot;col4&quot;, key: &quot;col4&quot;, title: &quot;Col4&quot;, width: 220 },
                    { field: &quot;col5&quot;, key: &quot;col5&quot;, title: &quot;Col5&quot;, width: 220 },
                    {
                        field: &quot;col6&quot;,
                        key: &quot;col6&quot;,
                        title: &quot;Col6&quot;,
                        width: 220,
                    },
                    { field: &quot;col7&quot;, key: &quot;col7&quot;, title: &quot;Col7&quot; },
                    { field: &quot;col8&quot;, key: &quot;col8&quot;, title: &quot;Col8&quot; },
                ],
                columnResizeInfo: {
                    column: &quot;&quot;,
                    differWidth: &quot;&quot;,
                    columnWidth: &quot;&quot;,
                    tableWidth: &quot;&quot;,
                },
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 5; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: Mock.Random.sentence(3, 12),
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        import Mock from "mockjs";
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{staticStyle:{"width":"100%"},attrs:{"scroll-width":0,"columns":_vm.columns,"table-data":_vm.tableData,"border-around":true,"border-x":true,"border-y":true,"column-width-resize-option":_vm.columnWidthResizeOption}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columnWidthResizeOption: {
                    // default false
                    enable: true,
                    // column resize min width
                    minWidth: 30,
                    // column size change
                    sizeChange: ({ column, differWidth, columnWidth }) => {
                        //
                    },
                },
                columns: [
                    {
                        field: "index",
                        key: "index",
                        title: "#",
                        width: 50,
                        align: "center",
                        fixed: "left",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                        disableResizing: true,
                    },
                    {
                        field: "col1",
                        key: "col1",
                        title: "Col1",
                        width: 220,
                        disableResizing: true,
                    },
                    {
                        field: "col2",
                        key: "col2",
                        title: "Col2",
                        width: 220,
                        disableResizing: true,
                    },
                    { field: "col3", key: "col3", title: "Col3", width: 220 },
                    { field: "col4", key: "col4", title: "Col4", width: 220 },
                    { field: "col5", key: "col5", title: "Col5", width: 220 },
                    {
                        field: "col6",
                        key: "col6",
                        title: "Col6",
                        width: 220,
                    },
                    { field: "col7", key: "col7", title: "Col7" },
                    { field: "col8", key: "col8", title: "Col8" },
                ],
                columnResizeInfo: {
                    column: "",
                    differWidth: "",
                    columnWidth: "",
                    tableWidth: "",
                },
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 5; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: Mock.Random.sentence(3, 12),
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  